import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'dod-banner',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class DoDBannerComponent {}
